"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "@/components/link";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { DonateDialog } from "@/components/donate-dialog";
const HIDDEN_ROUTE = /^\/event\/[^/]+\/edit\/times\/?$/;
export default function Footer() {
  const $ = _c(32);
  const pathname = usePathname();
  const t = useTranslations("footer");
  if (pathname && HIDDEN_ROUTE.test(pathname)) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const year = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link className="font-bold text-foreground hover:underline" href="/"><span>Heldenarbeit</span></Link>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("tagline");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex items-center gap-3"><div className="flex flex-col">{t1}<span>{t2}</span></div></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("privacy-policy");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Link className="hover:text-foreground" href="/privacy-policy">{t4}</Link>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("agb");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Link className="hover:text-foreground" href="/agb">{t6}</Link>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("impressum");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Link className="hover:text-foreground" href="#">{t8}</Link>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <DonateDialog />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t5 || $[20] !== t7 || $[21] !== t9) {
    t11 = <nav className="flex flex-wrap items-center gap-x-4 gap-y-2">{t5}{t7}{t9}{t10}</nav>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = String(year);
  let t13;
  if ($[23] !== t || $[24] !== t12) {
    t13 = t("copyright", {
      year: t12
    });
    $[23] = t;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <span>{t13}</span>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14 || $[30] !== t3) {
    t15 = <footer className="border-t border-border/40 bg-white dark:bg-black -mx-2"><div className="container mx-auto flex flex-col gap-4 py-6 px-4 text-sm text-muted-foreground md:flex-row md:items-center md:justify-between">{t3}{t11}{t14}</div></footer>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t3;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}